/**
 * A click the browser should resolve itself rather than us hijacking it:
 * modifier keys and non-primary buttons are how users ask for a new tab or
 * window. Turbolinks applies the same test in `clickEventIsSignificant` before
 * turning a link click into an in-page visit.
 *
 * `button !== 0` covers middle clicks in browsers that still report them as
 * `click` rather than `auxclick` (Safari before 15.4); elsewhere middle clicks
 * never reach a `click` handler and the browser handles them natively.
 */
export const isNewTabClick = (event: MouseEvent): boolean =>
  event.metaKey ||
  event.ctrlKey ||
  event.shiftKey ||
  event.altKey ||
  event.button !== 0
